@if (contactsDatasource) {
    <app-server-side-grid
        [colDefs]="gridColumns"
        [datasource]="contactsDatasource"
        [appliedSort]="appliedSort"
        [noRows]="noResults()"
        [titleNoData]="'No Contacts available.'"
        (cellSorting)="onSortChanged($event)"
    >
    </app-server-side-grid>
}
